import React, { useCallback } from 'react';
import CustomButton from 'components/Button/CustomButton';
import AddIcon from 'components/Icons/addIcon';
import { AddRow } from './style';
import { v4 as uuid } from 'uuid';
import { GroupData } from './types';
import { SUBMISSION_ACCESS, TEMPLATE_ACCESS } from './utils';

interface AddNewAccessProps {
  disabled?: boolean;
  className?: string;
  type: string;
  addNewGroup: (groupId: string, newGroupData: GroupData) => void;
}

const AddNewAccess: React.FC<AddNewAccessProps> = ({
  type,
  addNewGroup,
  disabled = false,
  className,
}) => {
  const handleAddNewAccess = useCallback(() => {
    if (disabled) return;

    const groupId = uuid();
    const newGroupData: GroupData = {
      isEveryone: false,
      AccessorIds: [],
      ...(type === TEMPLATE_ACCESS
        ? { role: 'submitter' }
        : { permission: 'CAN_VIEW_OWN_SUBMISSIONS' }),
      groupId: groupId,
      ...(type === SUBMISSION_ACCESS && { canEdit: false }),
    };
    addNewGroup(groupId, newGroupData);
  }, [addNewGroup, disabled]);

  return (
    <AddRow className={className}>
      <CustomButton
        variant="text"
        className="label"
        startIcon={<AddIcon className="addIcon" />}
        onClick={handleAddNewAccess}
        disabled={disabled}
        aria-label="Add new template access group"
        title="Add new template access group"
      >
        {type === TEMPLATE_ACCESS
          ? 'Add Template Access'
          : 'Add Submission Access'}
      </CustomButton>
    </AddRow>
  );
};
export default AddNewAccess;
